import axios from 'axios';
import { CONFIG } from '../lib/config';
import * as Sentry from '@sentry/react';
import { store } from '../store';
import { setUser } from '../store/slices/userSlice';
import { clearLoyaltyUserId } from '../modules/loyalty/libs/qrStorage';

const http = axios.create({
  baseURL: CONFIG.host_api,
});

http.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    // const language = localStorage.getItem('language');
    if (token) {
      config.headers['Token'] = `${token}`;
    }
    config.headers['os'] = 'tg';
    if (!config.headers.has('Accept-Language')) {
      // config.headers.set('Accept-Language', language);
    }

    if (!config.headers[`Content-Type`]) {
      config.headers[`Content-Type`] =
        'multipart/form-data; boundary=<calculated when request is sent>';
    }

    return config;
  },
  error => Promise.reject(error)
);

http.interceptors.response.use(
  response => {
    return response;
  },

  error => {
    if (error?.response?.status === 401) {
      // Mark 401 errors as handled since they're expected when token is invalid
      Sentry.captureException(error, {
        tags: {
          handled: true,
          error_type: 'auth_error',
        },
        level: 'warning',
        extra: {
          url: error?.config?.url,
          method: error?.config?.method,
          message:
            'User authentication failed - expected behavior when token is invalid',
        },
      });

      // Clear invalid token and update auth state
      localStorage.removeItem('token');
      // Аккаунта больше нет — офлайн-QR с его id показывать нельзя.
      clearLoyaltyUserId();

      // Update Redux state to reflect unauthenticated status
      const currentUser = store.getState().user;
      store.dispatch(
        setUser({
          ...currentUser,
          isAuth: false,
        })
      );
    }

    throw error;
  }
);

export default http;
